module.exports = __webpack_public_path__ + "img/1.8f213625.png";